module.exports = __webpack_public_path__ + "img/pr-5.4c15dfb2.png";